var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57751 0.744641L5.00001 4.32214L1.42251 0.744641C1.26535 0.592843 1.05484 0.508848 0.836346 0.510746C0.617849 0.512645 0.408838 0.600286 0.254332 0.754792C0.0998249 0.909299 0.0121841 1.11831 0.0102854 1.33681C0.00838673 1.5553 0.0923821 1.76581 0.24418 1.92297L4.41085 6.08964C4.56712 6.24587 4.77904 6.33363 5.00001 6.33363C5.22098 6.33363 5.43291 6.24587 5.58918 6.08964L9.75585 1.92297C9.83544 1.8461 9.89892 1.75415 9.9426 1.65248C9.98627 1.55081 10.0093 1.44146 10.0102 1.33081C10.0112 1.22016 9.9901 1.11043 9.9482 1.00801C9.9063 0.905599 9.84442 0.812556 9.76618 0.734312C9.68793 0.656068 9.59489 0.594191 9.49248 0.55229C9.39006 0.510389 9.28033 0.489304 9.16968 0.490266C9.05903 0.491227 8.94968 0.514216 8.84801 0.55789C8.74634 0.601564 8.65439 0.665049 8.57751 0.744641Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/Dropdown_arrow.40073eefff3e4b05099e8d193465d793.svg";
export { ForwardRef as ReactComponent };